import * as React from 'react';
import DataTable from "react-data-table-component";

function paginationComponent(props) {
  return 'pagination';
}

interface ICardProps {
  data: any[];
  columns: any[];
}
function ChainTable(props:ICardProps) {
 
  return (
    <>

      <DataTable
        columns={props.columns}
        data={props.data}
        noHeader
        pagination={false}
        paginationPerPage={5}
        paginationRowsPerPageOptions={[5,10, 25, 100]}
        paginationIconFirstPage= {false}
        paginationIconLastPage= {false}
        dense
      />
    </>
  );
    
}

export default ChainTable;

